module.exports = __webpack_public_path__ + "static/media/testimonials_bg.b900d05d.jpg";